/* ==========================================================================
   OVERLAY DRAWER — Standalone JS (no OLD dependencies)
   ========================================================================== */
(function () {
  'use strict';

  var CLOSE_DURATION = 300; // ms — matches CSS animation duration

  /* --- Animated close helper --- */
  function closeOverlay(dialog) {
    if (!dialog || !dialog.open || dialog.hasAttribute('data-closing')) return;

    dialog.setAttribute('data-closing', '');

    // Skip animation if user prefers reduced motion
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      dialog.removeAttribute('data-closing');
      dialog.close();
      return;
    }

    setTimeout(function () {
      dialog.removeAttribute('data-closing');
      dialog.close();
    }, CLOSE_DURATION);
  }

  /* --- iOS-safe scroll lock --- */
  var savedScrollY = 0;

  function lockScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    var scrollY = savedScrollY;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  /* --- Open trigger --- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-overlay-open]');
    if (!trigger) return;

    e.preventDefault();
    var id = trigger.getAttribute('data-overlay-open');
    var dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return;

    dialog.showModal();
    lockScroll();
  });

  /* --- Close trigger (button inside dialog) --- */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-overlay-close]');
    if (!closer) return;

    var dialog = closer.closest('dialog');
    if (!dialog) return;

    closeOverlay(dialog);
  });

  /* --- Backdrop click to close --- */
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof HTMLDialogElement)) return;
    if (!e.target.open) return;

    // Check if click is on the backdrop (outside the panel)
    var rect = e.target.getBoundingClientRect();
    var panel = e.target.querySelector('.overlay-drawer__panel');
    if (!panel) return;

    var panelRect = panel.getBoundingClientRect();
    var isOutside =
      e.clientX < panelRect.left ||
      e.clientX > panelRect.right ||
      e.clientY < panelRect.top ||
      e.clientY > panelRect.bottom;

    if (isOutside) {
      closeOverlay(e.target);
    }
  });

  /* --- Restore body scroll on close --- */
  document.addEventListener('close', function (e) {
    if (!(e.target instanceof HTMLDialogElement)) return;
    if (!e.target.classList.contains('overlay-drawer')) return;
    unlockScroll();
  }, true);
})();
